import React, { useCallback, useContext, useState, useEffect } from "react";
import {
	Container,
	Row,
	Col,
	Form,
	Card,
	Button,
	Accordion,
	Image,
	CloseButton,
	Table
} from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import { AppContext } from "../../context/appContext";

const BakeryList = () => {
	const navigate = useNavigate();
	const { setGlobalLoading } = useContext(AppContext);

	const [bakeries, setBakeries] = useState([]);

	const fetchBakeries = useCallback(
		async () => {
			try {
				setGlobalLoading(true);
				const response = await axios.get(
					"https://lucvle8pqe.execute-api.us-east-1.amazonaws.com/v1/getBakeries-dev",
				);

				if (
					response.data &&
					response.data.bakeryStores &&
					Array.isArray(response.data.bakeryStores)
				) {
					const bakeryStores = response.data.bakeryStores;
					setBakeries(bakeryStores.slice(0, 10)); // ✅ Ensure we only take 10 results
					setGlobalLoading(false);
				} else {
					console.error("❌ API returned an unexpected format:", response.data);
					setBakeries([]); // Set empty array if no valid data
					setGlobalLoading(false);
				}
			} catch (error) {
				console.error("❌ Error fetching bakeries:", error);
			}
		},
		[setGlobalLoading],
	);  

	useEffect(() => {
		fetchBakeries();
	}, [fetchBakeries]);

  return (
			<Container className="py-5">
				<Card className="shadow-sm" style={{ borderRadius: "15px" }}>
					<Card.Body style={{ padding: "30px" }}>
						<Table striped bordered hover>
							<thead>
								<tr>
									<th>#</th>
									<th>Bakery Name</th>
									<th>Reviews</th>
									<th>Rating</th>
									<th></th>
								</tr>
							</thead>
							<tbody>{bakeries?.map((d, i) => {
								return (
									<tr key={i.toString()}>
										<td>{i + 1}</td>
										<td>{d.bakeryName}</td>
										<td>{d.reviews}</td>
										<td>{d.rating}</td>
										<td>
											<Button
												variant="primary"
												onClick={() => navigate(`/control/bakery/${d.accountId}`)}>
												Modify
											</Button>
										</td>
									</tr>
								);
							})}</tbody>
						</Table>
					</Card.Body>
				</Card>
			</Container>
		);
}

export default BakeryList;